import { memo } from "react";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

type Props = {
    readonly page: number;
    readonly pageCount: number;
    readonly onChange: (page: number) => void;
    readonly disabled?: boolean;
};

const SimplePagination = ({ page, pageCount, onChange, disabled }: Props) => {
    const isPrevDisabled = disabled || page <= 1;
    const isNextDisabled = disabled || page >= pageCount;

    const goPrev = () => {
        if (isPrevDisabled) return;
        onChange(page - 1);
    };

    const goNext = () => {
        if (isNextDisabled) return;
        onChange(page + 1);
    };

    return (
        <Stack
            direction='row'
            alignItems='center'
            justifyContent='space-between'
            sx={{ width: '100%' }}
        >
            <Typography variant='body2' color='text.primary'>
                {page} of {pageCount}
            </Typography>
            <Stack direction='row' alignItems='center' spacing={0.5}>
                <IconButton
                    size='small'
                    onClick={goPrev}
                    disabled={isPrevDisabled}
                    aria-label='Previous page'
                    data-test-id='pagination.prev'
                >
                    <ChevronLeftIcon />
                </IconButton>
                <IconButton
                    size='small'
                    onClick={goNext}
                    disabled={isNextDisabled}
                    aria-label='Next page'
                    data-test-id='pagination.next'
                >
                    <ChevronRightIcon />
                </IconButton>
            </Stack>
        </Stack>
    );
};

export default memo(SimplePagination);
